
// Action: file_editor create /app/frontend/src/data/testimonials.js --file-text 
export const testimonialsData = [
  {
    id: 1,
    name: "Rajesh Kumar",
    rating: 5,
    message: "Excellent finishing and professional work. Highly satisfied with the modular kitchen design. The team understood our requirements perfectly and delivered beyond expectations.",
    project: "Modular Kitchen"
  },
  {
    id: 2,
    name: "Priya Sharma",
    rating: 5,
    message: "Outstanding glass work! The partitions transformed our office space completely. Very professional team and timely delivery. Highly recommended!",
    project: "Office Glass Partition"
  },
  {
    id: 3,
    name: "Amit Patel",
    rating: 5,
    message: "Beautiful interior design for our home. The attention to detail and quality of materials used is exceptional. Worth every penny!",
    project: "Living Room Interior"
  },
  {
    id: 4,
    name: "Sneha Reddy",
    rating: 5,
    message: "Professional service from start to finish. The wardrobe and false ceiling work exceeded our expectations. Truly skilled craftsmen!",
    project: "Bedroom Interior"
  },
  {
    id: 5,
    name: "Vikram Singh",
    rating: 5,
    message: "Impressed with the modern design and flawless execution. The team was courteous and completed the work within the promised timeline.",
    project: "Commercial Interior"
  }
];

// Observation: Create successful: /app/frontend/src/data/testimonials.js